import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const CircleIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M8.00016 1.3335C4.3135 1.3335 1.3335 4.3135 1.3335 8.00016C1.3335 11.6868 4.3135 14.6668 8.00016 14.6668C11.6868 14.6668 14.6668 11.6868 14.6668 8.00016C14.6668 4.3135 11.6868 1.3335 8.00016 1.3335ZM8.00016 13.3335C5.0535 13.3335 2.66683 10.9468 2.66683 8.00016C2.66683 5.0535 5.0535 2.66683 8.00016 2.66683C10.9468 2.66683 13.3335 5.0535 13.3335 8.00016C13.3335 10.9468 10.9468 13.3335 8.00016 13.3335Z" />
  </Icon>
);

export default memo(CircleIcon);
